<template>
  <p class="info">
    * Precio mensual estimado. <br />
    ** Precios: los valores pueden ajustarse según la tarifa que se actualiza
    trimestralmente y la modificación del grupo familiar. En caso que trabajes
    en Relación de Dependencia el importe podrá variar según tu sueldo.
  </p>
</template>

<script>
export default {
  name: "PlanInfo",
};
</script>

<style scoped>
.info {
  font-size: 14px;
  max-width: 80%;
  margin: 0 auto;
}
</style>
